<template>
  <ul>
    <li v-for="(gridColumn, index) in availableGridColums" :key="index">
      <input :id="level + '-' + index"
             v-model="gridColumn.show"
             type="checkbox"
             @click="onClickGridColumn(gridColumn)"
      >

      <label :for="level + '-' + index">{{ gridColumn.text | capitalize }}</label>

      <grid-columns-visibility v-if="gridColumn.children"
                               v-show="gridColumn.show"
                               :grid-columns.sync="gridColumn.children"
                               :level="level + '-' + index"
                               :show-all.sync="gridColumn.show"
      />
    </li>
  </ul>
</template>

<script>
import { filter, each } from 'lodash-es'

export default {
  name: 'GridColumnsVisibility',

  props: {
    gridColumns: {
      type: Array,
      required: true
    },
    level: {
      type: String,
      default: '1'
    },
    showAll: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    availableGridColums () {
      return filter(this.gridColumns, col => !!col.text)
    }
  },

  watch: {
    showAll (showAll) {
      if (showAll) { // In case parent is shown => if any column is shown then do nothing else show all the columns
        let sync = true
        each(this.gridColumns, gridColumn => {
          if (gridColumn.show) {
            sync = false
            return false
          }
        })
        if (sync) {
          each(this.gridColumns, gridColumn => {
            gridColumn.show = true
          })
        }
      } else { // In case parent is hidden => hide all columns
        each(this.gridColumns, gridColumn => {
          gridColumn.show = false
        })
      }
    }
  },

  methods: {
    onClickGridColumn (gridColumn) {
      let showAll = false
      each(this.gridColumns, gridColumn => {
        showAll = showAll || gridColumn.show
      })
      this.$emit('update:showAll', showAll)
    }
  }
}
</script>

<style scoped lang="scss">
  ul {
    max-height: 550px;
    overflow-y: auto;
    list-style: none;

    li {
      margin: 5px 0;
    }
  }
</style>
